import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Categories from './pages/Categories';
import ProductsCategories from './pages/ProductsCategories';
import SubProducts from './pages/SubProducts';
import Services from './pages/Services';
import Blog from './pages/Blog';
import Podcast from './pages/Podcast';
import Resources from './pages/Resources';
import Career from './pages/Career';
import Support from './pages/Support';
import RFQ from './pages/RFQ';
import Contact from './pages/Contact';
import PageManagement from './pages/PageManagement';
import Users from './pages/Users';
import './index.css';

function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/products" element={<ProductsCategories />} />
          <Route path="/sub-products/:productId" element={<SubProducts />} />
          <Route path="/categories" element={<Categories />} />
          <Route path="/services" element={<Services />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/podcast" element={<Podcast />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/career" element={<Career />} />
          <Route path="/support" element={<Support />} />
          <Route path="/rfq" element={<RFQ />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/pages" element={<PageManagement />} />
          <Route path="/users" element={<Users />} />
          <Route path="/" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            duration: 3000,
            style: {
              background: '#10B981',
            },
          },
          error: {
            duration: 5000,
            style: {
              background: '#EF4444',
            },
          },
        }}
      />
    </div>
  );
}

export default App;
